export class ProductCode {
  public static NonRenewing = ['NonRenewing'];
  public static SingleGameBuyer = ['SingleGameBuyer'];
  public static STH = [
    'GRITGRIND',
    'PREMIUM',
    'ALLHEART',
    'NEXTGEN',
    'BELIEVEMEMPHIS',
    'FIRSTGEN',
    'All-Star',
    'Hall of Fame',
    'Legend',
    'OG',
    'Rookie',
  ];
}
